import { z } from 'zod';

export const AlertActiveSchema = z.object({
  show_banner: z.boolean(),
  show_popup: z.boolean(),
  show_status_transaction: z.boolean(),
  message_banner: z.string(),
  message_popup: z.string(),
  message_status_transaction: z.string(),

  services_status: z.object({
    REGISTERSERVICE: z.union([z.boolean(), z.number().int().min(0).max(1)]).optional(),
    PIXSERVICE: z.union([z.boolean(), z.number().int().min(0).max(1)]).optional(),
    PIXSERVICEPAY: z.union([z.boolean(), z.number().int().min(0).max(1)]).optional(),
  }).optional(),

  status_bot_pix: z.number().int().min(0).max(1).optional(),
});

export const AlertApiResponseSchema = z.object({
  status: z.number(),
  message: z.string(),
  data: AlertActiveSchema,
});

export type AlertActive = z.infer<typeof AlertActiveSchema>;
export type AlertApiResponse = z.infer<typeof AlertApiResponseSchema>;
